/**
 * Returns an array length.
 * @param {Array} list
 */
export function length(list) {
    return list.length;
};

export default { length };
